<template>
    <!-- 管理员登陆 -->
    <div class='login'>
        <div class='head'>
            <img class='yl_logo' src="../../assets/images/yiliLogo.svg" alt="">
        </div>
        <div>
            <h1 class='logo'>{{config.title}}<span v-if='isDev'>测试环境</span></h1>
            <el-form class="form_box" :model="form" status-icon :rules="rules" ref="loginForm">
                <!-- 账号 -->
                <el-form-item class='form_item' prop="username">
                    <el-input
                        minlength="3"
                        autosize
                        clearable
                        prefix-icon="font_family ds-icon-yonghu"
                        maxlength="50"
                        v-model="form.username"
                        autocomplete="off"
                        placeholder="请输入账号名"
                    ></el-input>
                </el-form-item>
                <!-- 密码 -->
                <el-form-item class='form_item' prop="password">
                    <el-input
                        type="password"
                        placeholder="请输入密码"
                        prefix-icon="font_family ds-icon-mima"
                        v-model="form.password"
                        clearable
                        autocomplete="new-password"
                    ></el-input>
                </el-form-item>
            </el-form>
            <el-button type="primary" class="btn" @click="login" :loading='loading' :disabled="loading">{{loading?"登 录 中 ...":"登 录"}}</el-button>
        </div>
    </div>
</template>

<script>
    import config from "../config.js" 
    export default {
        data() {
            return {
                config,
                loading: false,
                form: {
                    username: "",
                    password: "",
                },
                rules: {
                    username: [
                    { required: true, message: "请输入账号名称", trigger: "blur" },
                    {
                        min: 3,
                        max: 50,
                        message: "账号名称长度必须为3-50个字符内",
                        trigger: "blur"
                    }
                    ],
                    password: [{ required: true, message: "请输入密码", trigger: "blur" }]
                }
            }
        },
        computed: {
            isDev() {
                return process.env.NODE_ENV === "development"
            }
        },
        created() {
            let token = localStorage.getItem('token');
            if(token) this.$router.replace('/home');
        },
        methods: {
            login() {
                // 表单验证
                if(this.form.username == '' || this.form.password == '') {
                    this.$refs.loginForm.validate();
                    return
                }
                this.loading = true;
                this.$http({
                    url: this.$api.login,
                    data: {
                        loginName: this.form.username,
                        password: this.form.password
                    }
                }).then(res => {
                    this.loading = false;
                    if(res.code == 0) {
                        localStorage.setItem('token',res.data);
                        localStorage.setItem('username',this.form.username);
                        this.$router.replace('/home')
                         this.$message({
                            message: '登录成功',
                            type: 'success'
                        });
                        this.form.username = '';
                        this.form.password = '';
                    }else {
                        this.$message.error(res.message);
                    }
                }).catch( err => {
                    this.loading = false;
                    this.$message.error(res.message);
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "../../assets/css/common.scss";
.logo {
    margin-bottom: 48px;
}
</style>


// WEBPACK FOOTER //
// src/pages/login/adminLogin.vue